import React, { PureComponent } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faWrench, faBan, faCogs } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";

import './partner.scss'
import Swal from "sweetalert2/dist/sweetalert2";
import {language, swalText} from "../../../../Constants";
import Helpers from "../../../../libs/helpers";

library.add(faInfo, faWrench, faBan, faCogs );
export default class Partner extends PureComponent{
    render() {

        const { id, src } = this.props;
        return (
            <div className={'partner'} id={`#partner-${id}`}>
                <div className={'partnerImage'}>
                    <img src={'/images/partners/' + src} alt=""/>
                </div>
                <div className={'partnerTools'}>
                    <span title={'Տեսնել Ավելին'} onClick={this.showMore}><FontAwesomeIcon icon={'info'}/></span>
                    <span title={'Փոխել Ճանապարհը'} onClick={this.updPartner}><FontAwesomeIcon icon={'wrench'}/></span>
                    <span title={'Փոխել Նկարը'} onClick={this.changeMain}><FontAwesomeIcon icon={'cogs'}/></span>
                    <span title={'Ջնջել Գործընկերոջը'} onClick={this.delPartner}><FontAwesomeIcon icon={'ban'}/></span>
                </div>
            </div>
        )
    }

    showMore = () => {
        Swal.fire({
            type: 'info',
            confirmButtonText: swalText.ok,
            showCloseButton: true,
            html: `
                <div>${this.props.url}</div>
                <div><b>${language[0].name}: </b>${this.props.data[0].name}</div>
                <div><b>${language[1].name}: </b>${this.props.data[1].name}</div>
                <div><b>${language[2].name}: </b>${this.props.data[2].name}</div> 
            `
        })
    };
    updPartner = () => {
        Swal.fire({
            type: 'question',
            title: swalText.change,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true,
            html: `
                <div id='partnerTag'>   
                    <section>
                        <div><b>Գործընկերոջ կայքի հասցեն: </b></div>
                        <div><input type="url" id='newLink' value="${this.props.url}" required min='3'></div>
                    </section>
                    <section id="updName">
                        <div><b>${language[0].name}: </b><input type="text" value="${this.props.data[0].name}" required min='3'></div>
                        <div><b>${language[1].name}: </b><input type="text" value="${this.props.data[1].name}" required min='3'></div>
                        <div><b>${language[2].name}: </b><input type="text" value="${this.props.data[2].name}" required min='3'></div>
                    </section>
                </div>  
            `
        }).then(result => {
            let newLink = document.querySelector('#newLink').value.trim();
            let info = [...document.querySelectorAll('#partnerTag > #updName input')].map(el => el.value.trim());
            const { id } = this.props;

            if (result.value && Helpers.checkUrl(newLink)) {
                axios.post('/api/partners/upd', { newLink, id, info }).then(({ data }) => {
                    if (data.message === 'partner updated')
                        this.props.changePartner(data.result);
                })
            }
        })
    };
    changeMain = () => {
        document.querySelector('#mySecondModule').classList.add('openModule');
        document.querySelector('#mySecondModule').dataset.id = this.props.id;
        document.addEventListener('click', this.props.closeModule);
        this.props.printImage(this.props.src);
    };
    delPartner = () => {
        Swal.fire({
            type: 'question',
            title: swalText.del,
            text: swalText.delMore,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true
        }).then(result => {
            const { id } = this.props;
            if (result.value) {
                axios.delete(`/api/partners/delById/${id}`).then(({ data }) => {
                    if (data.message === 'partner deleted')
                        this.props.changePartner(data.result);
                })
            }
        })
    }
}
